import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=18b24a12&"
import script from "./PageFooter.vue?vue&type=script&lang=coffee&"
export * from "./PageFooter.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports